// Monkey patches our custom logger objects onto the global console object
// Tried this originally by injected them into the window (web)/global (RN) scope,
// but linters were still giving issues even with rules overwriting, so decided to
// monkey patch it in.

import { devLog, activityLog } from 'modules/logger';

// Trying to combine this with above import leads to isolateModules errors
import { Logger, LoggerData } from 'modules/logger/src/LoggerType';

// Use global augmentation declaration merging to add our monkey patch to the global typescript scope
declare global {
  interface Console {
    devLog: Logger;
    activityLog: Logger;
  }
}

console.devLog = devLog;
console.activityLog = activityLog;
